import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { SectionList, StyleSheet, } from 'react-native';
import { groupBy } from 'lodash';
import { formatStatementPeriodName } from 'common';
import { API } from '@xbto/api-client';
import { theme } from '@xbto/design-system';
import { Button, Row, TextBody } from '../../atoms';
import { FundStatementListItem, StatementListItem } from './item';
import { LoadingIndicator } from '../../molecules';
export function StatementList({ data, header, onPressItem, onPaginate, paginable, paginating = false, }) {
    // Vars
    const sections = useMemo(() => {
        const byPeriod = groupBy(data, item => {
            return formatStatementPeriodName(item);
        });
        const result = [];
        Object.entries(byPeriod).forEach(([title, data]) => {
            result.push({ title, data });
        });
        return result;
    }, [data]);
    // Handlers
    const renderItem = useCallback((item) => {
        var _a;
        if (!item.accountLabel || !item.accountNumber || !item.accountType) {
            return null;
        }
        if (item.accountType === API.AccountType.Fund && ((_a = item.currency) === null || _a === void 0 ? void 0 : _a.name)) {
            return (_jsx(FundStatementListItem, { id: item.accountStatementId, accountId: item.accountId, accountLabel: item.accountLabel, accountNumber: item.accountNumber, accountType: item.accountType, fundName: item.currency.name, onPress: onPressItem }));
        }
        return (_jsx(StatementListItem, { id: item.accountStatementId, accountId: item.accountId, accountLabel: item.accountLabel, accountNumber: item.accountNumber, accountType: item.accountType, onPress: onPressItem }));
    }, [onPressItem]);
    const handleRenderItem = useCallback(({ item }) => renderItem(item), [renderItem]);
    const renderSectionHeader = useCallback(({ section }) => (_jsx(TextBody, { small: true, lhFull: true, style: $.sectionHeader, children: section.title })), []);
    // Render
    return (_jsx(SectionList, { ListFooterComponent: paginable ? (_jsx(Row.C, { p: "8", children: paginating ? (_jsx(LoadingIndicator, {})) : (_jsx(Button, { label: "Load more", variant: "tertiary", size: "sm", onPress: onPaginate })) })) : null, ListHeaderComponent: header, renderItem: handleRenderItem, renderSectionHeader: renderSectionHeader, sections: sections }));
}
const $ = StyleSheet.create({
    sectionHeader: {
        marginTop: theme.spacing['8'],
        marginBottom: theme.spacing['4'],
    },
});
